import {
  Component,
  computed, effect,
  ElementRef,
  input, linkedSignal,
  model, OnInit,
  output,
  Signal,
  signal,
  viewChild,
  WritableSignal
} from '@angular/core';
import {ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'search-dropdown',
  imports: [
    FormsModule
  ],
  templateUrl: './search-dropdown.component.html',
  styleUrl: './search-dropdown.component.scss',
  providers: [
    { provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: SearchDropdownComponent
    }
  ]
})
export class SearchDropdownComponent implements ControlValueAccessor  {
  //UI
  container = viewChild<ElementRef>('container');
  disabled : WritableSignal<boolean> = signal(false);
  //INPUT
  form_control = input<FormControl|null>(null);
  max_height_px = input<number>(200);
  //OUTPUT
  value = model<any>(null);
  //DATA
  query = signal('');
  // query = linkedSignal({source: ()=> this.selected_item()?.name ?? '',
  //                                          computation:(value)=> value});
  items = input<SearchDropdownItem[]>([]);
  items_raw = computed(()=>this.sortItems(this.items()));
  placeholder = input<string>('');
  // top optimize search
  items_cache: Signal<tempSearch[]> = computed(()=> this.searchCache(this.items_raw()) );
  items_filtered = computed(()=> this.searchItems(this.query()));
  //
  selected_item: WritableSignal<SearchDropdownItem|null> = signal(null);

  //FORM CONTROL CALLBACKS
  onChange = (value: any)=>{};
  onTouched = ()=>{};

  constructor() {
  }
  selectItem(item: SearchDropdownItem){
    this.query.set(item.name);
    this.value.set(item.value);
    this.selected_item.set(item);
    this.onChange(this.value());
    this.onTouched();
    this.blur();
  }
  blur(){
    this.container()?.nativeElement.blur();
  }
  searchItems(query: string){
    if(!query){
      return this.items_raw();
    }
    const q = this.query().toLowerCase();
    return this.items_cache().filter(s=> s.name_lowercase.includes(q) || (s.keywords ?? '').toLowerCase().includes(q))
                             .sort((a,b)=>a.name_lowercase.localeCompare(b.name_lowercase))
                             .map(i=> ({name: i.name , keywords: i.keywords, value: i.value}));

  }
  searchCache(items: SearchDropdownItem[]){
    return items.map(i => ({...i,name_lowercase: i.name.toLowerCase()}))
                .sort((a,b)=>a.name_lowercase.localeCompare(b.name_lowercase));
  }
  clearSelection(){
    this.form_control()?.setValue(null);
    this.selected_item.set(null);
    this.value.set(null);
    this.onChange(this.value());
    this.onTouched();
  }
  sortItems(items: SearchDropdownItem[]){
    return items.sort((a,b)=>a.name.localeCompare(b.name));
  }
  //ControlValueAccessor METHODS

  writeValue(obj: any): void {
    const item = this.items().find(i => i.value === obj);
    !!item? this.selectItem(item): this.clearSelection();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
export interface SearchDropdownItem {
  name: string;
  keywords?: string;
  value: any;
}
interface tempSearch extends SearchDropdownItem {
  name_lowercase: string;
}
